module.exports = __webpack_public_path__ + "img/wave-top.451cff69.svg";